// extracted by mini-css-extract-plugin
module.exports = {"root":"TableHeading_root__1hreY","clinicsSelect":"TableHeading_clinicsSelect__aMX29"};